// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

export const productListCardListBreakpoints = {
    tablet: 1220,
    mobile: 660,
};

export const partNumberStyle: { label: TypographyPresentationProps; value: TypographyPresentationProps } = {
    label: {
        size: 12,
        weight: "normal",
        transform: "capitalize",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
            margin-right: 5px;
            flex-shrink: 0;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 18px;
        `,
    },
};
